import { LogisticsModel, PartnersModel } from '../../shared/models/logistics-model';
import { PagedRequest } from '../../shared/models/paged-request.model';
import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { AggregatorCardModel, Card } from '../../shared/models/card-model';
import { ReplaySubject, Subject } from 'rxjs';
import { DeviceRegistrationOtpModel } from '../../shared/models/device.model';
import { KycDashboardData } from '../../shared/models/dashboard.model';
import { StringHelper } from '../helpers/strings.helper';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class LogisticsService {

	partnerObj: Subject<PartnersModel[]> = new ReplaySubject();
	private partners: PartnersModel[];
	private openRequests: number = 0;

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
		private localStorage: LocalStorageService,
	) {
	}

	setPartners(config: PartnersModel[]) {
		this.partners = config;
	}

	getPartners() {
		return this.partners;
	}

	setOpenRequests(openRequests: number) {
		this.openRequests = openRequests
	}

	getOpenRequests() {
		return this.openRequests;
	}




	getPartnersfromUrl(): Promise<LogisticsModel> {
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/partners`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPartnersforFulfilmentCenter(code): Promise<LogisticsModel> {
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/partners?fulfilmentCenterCode=${code}`;
		return this.apiClientHelper.getForPromise(url);
	}


	releaseCardBatch(params: any): Promise<any> {
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/card-pickup-batch`;
		return this.apiClientHelper.postForPromise(url, params)
	}


	getFulfillmentCenterBatches(param: any): Promise<any> {
		const params = StringHelper.toUrlString(param);
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/cards/fulfillment-center/display-batches?${params}`;
		return this.apiClientHelper.getForPromise(url);
		}

	getFulfillmentCenterCompletedBatches(param: any): Promise<any> {
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/cards/fulfillment-center/display/completed-batches`;
		return this.apiClientHelper.postForPromise(url, param);

	}

	getOpenRequestByFulfillmentCenter(fulfillmentCenterCode: string): Promise<any> {
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/cards/requests/fulfillment-center/${fulfillmentCenterCode}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getOpenFulfillmentCenterRequests(param: any): Promise<any> {
		const params = StringHelper.toUrlString(param);
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/cards/task/fulfillment-centers-count?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getCardRequestPreview(param: any): Promise<any> {
		const params = StringHelper.toUrlString(param);
		const url = this.config.MONIEPOINT_CARDS + `/api/v1/cards/delivery-cost?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}


	getSubLGAs(): Promise<any> {
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/sub-lgas`;
		return this.apiClientHelper.getForPromise(url);
	}

	getSubLGAsById(id: any): Promise<any> {
		const url = this.config.MONIEPOINT_LOGISTICS + `/api/v1/logistics/sub-lgas/${id}`;
		return this.apiClientHelper.getForPromise(url, null, false);
	}

}
